import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const langGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const allowedLangs = ['id', 'en'];
  const lang = route.params['lang'];

  if (allowedLangs.includes(lang)) {
    return true;
  }

  const requestedUrl = state.url || '/';
  const [pathWithoutQuery, queryAndFragment = ''] = requestedUrl.split(/(?=[?#])/);
  const normalizedPath = pathWithoutQuery.startsWith('/') ? pathWithoutQuery : `/${pathWithoutQuery}`;
  const remainingPath = normalizedPath.replace(new RegExp(`^/${lang}(?=/|$)`), '') || '/';

  return router.parseUrl(`/id${remainingPath}${queryAndFragment}`);
};
